import { render, staticRenderFns } from "./DocumentElementViewer.vue?vue&type=template&id=2be8f7bc&lang=pug"
import script from "./DocumentElementViewer.vue?vue&type=script&lang=js"
export * from "./DocumentElementViewer.vue?vue&type=script&lang=js"
import style0 from "./DocumentElementViewer.vue?vue&type=style&index=0&id=2be8f7bc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports